import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

export function authGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    auth.setReturnUrl(state.url);
    auth.requestLogin();
    return !router.navigated ? router.createUrlTree(['/']) : false;
  }
  return true;
}
